import { performPublicConfigHttpLoad } from "@Front/Config/configRuntimePerformFetch";

let isLoadingConfig = false;
let configLoadPromise: Promise<void> | null = null;
let lastConfigLoadAt = 0;
const CONFIG_LOAD_THROTTLE_MS = 5_000;

/**
 * Loads public config from the backend and updates FrontendVariables.
 * Keys are not renamed; values are overwritten only when present in the response.
 * Guarded against concurrent calls and frequent reloads.
 */
export async function loadPublicConfigRuntime(): Promise<void> {
	if (typeof window === "undefined") return;

	const now = Date.now();
	if (now - lastConfigLoadAt < CONFIG_LOAD_THROTTLE_MS && lastConfigLoadAt > 0) {
		return Promise.resolve();
	}

	if (isLoadingConfig && configLoadPromise) {
		return configLoadPromise;
	}

	isLoadingConfig = true;
	configLoadPromise = (async (): Promise<void> => {
		try {
			await performPublicConfigHttpLoad(() => {
				lastConfigLoadAt = Date.now();
			});
		} finally {
			isLoadingConfig = false;
			configLoadPromise = null;
		}
	})();

	return configLoadPromise;
}
